// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle/squadbusters/" + chunkId + "." + {"338":"ad7c2fe67a63b83d88a1","362":"a9b3693c41348c77f386","613":"643554a06b0d2e5cb5db","632":"3a8f6eecd773711a50ad","679":"db021678b2dbb9081baa","813":"9d132117e161c5a0a179","870":"a8c0560034c1ef4a8c7d","954":"0fb8740ce742db2eb2ac","996":"1f87b4e176ccfa68f74d"}[chunkId] + ".min.js";
};